import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export enum DayJSDateStringFormat {
    YYYYMM = 'YYYY-MM',
    YYYYMMDD = 'YYYY-MM-DD',
    YYYYMMDDHHMM = 'YYYY-MM-DD HH:mm',
    HHMM = 'HH:mm'
}

export class DateUtility {
    static CurrentTimeZone = -(new Date().getTimezoneOffset() / 60);

    static isValidDateStringByFormat(
        dateString: string,
        format: DayJSDateStringFormat = DayJSDateStringFormat.YYYYMMDD
    ): boolean {
        return DateUtility.toDateByFormat(dateString, format).isValid();
    }

    static toDayJS(date: string | Date): dayjs.Dayjs {
        return dayjs(date);
    }

    static toDateByFormat(
        dateString: string,
        format: DayJSDateStringFormat = DayJSDateStringFormat.YYYYMMDD
    ): dayjs.Dayjs {
        return dayjs(dateString, format, true);
    }

    static toFormattedString(
        date: Date | dayjs.Dayjs,
        format: DayJSDateStringFormat = DayJSDateStringFormat.YYYYMMDD
    ): string {
        const parsedDate = dayjs(date);
        return parsedDate.format(format);
    }

    static compare(date1: dayjs.Dayjs, date2: dayjs.Dayjs): number {
        return DateUtility.resetTime(date1).diff(DateUtility.resetTime(date2));
    }

    static compareByFormat(date1: string, date2: string): number {
        const firstDate = DateUtility.toDateByFormat(date1);
        const secondDate = DateUtility.toDateByFormat(date2);
        return DateUtility.compare(firstDate, secondDate);
    }

    static resetTime(date: dayjs.Dayjs): dayjs.Dayjs {
        return date.hour(0).minute(0).second(0).millisecond(0);
    }

    static copyTime(target: dayjs.Dayjs, source: dayjs.Dayjs): dayjs.Dayjs {
        return target.hour(source.hour()).minute(source.minute()).second(source.second()).millisecond(source.millisecond());
    }

    /**
     * Convert a date to an UTC date that has the same timestamp
     * @param inputDate a date that has the timestamp that wants to have the same date, hour, minute... but are of UTC timezone
     * @param offset number of hours offset from UTC+00:00 to correct for a provided timezone
     */
    static convertToUTC(inputDate: dayjs.Dayjs, offset: number = 0): dayjs.Dayjs {
        const utcDate = new Date();
        utcDate.setUTCDate(inputDate.date());
        utcDate.setUTCMonth(inputDate.month());
        utcDate.setUTCFullYear(inputDate.year());
        utcDate.setUTCHours(inputDate.hour() + offset);
        utcDate.setUTCMinutes(inputDate.minute());
        utcDate.setUTCSeconds(inputDate.second());
        utcDate.setUTCMilliseconds(inputDate.millisecond());
        return dayjs(utcDate);
    }

    static getCurrentYear(): number {
        const today = new Date();
        const thisYear = today.getFullYear();
        return thisYear;
    }
}
